import request from '@/plugins/request';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/error';

export interface IError {
  id: number,
  message: string,
  stackTrace: string,
  summary: string,
  addDate: Date,
}

interface IGetResult {
  error: IError,
}

export default {
  get(logId: number, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: {
          logId,
        },
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
